import classNames from "classnames"
import { Check } from "lucide-react";
import { ReactNode } from "react";

export function BenefitItem({ children, className }: {children?: ReactNode, className?: string }) {
  return (
    <div className={classNames(
      "flex items-center gap-2 rounded-xl border bg-[#EDF6FF] px-3 py-3 text-xs",
      "sm:text-[11px] sm:px-2.5 sm:py-2.5 mx-2",
      className
    )}>
      <span
        className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0762D7] text-[white] sm:h-4 sm:w-4"
        aria-hidden="true"
      >
        <Check className="h-3.5 w-3.5 sm:h-3 sm:w-3" strokeWidth={3} />
      </span>
      <span className="text-[#0C0C0C] font-medium">{children}</span>
    </div>
  );
}
